import { CSSProperties, SVGProps } from 'react';

import { COLORS } from '../../../lib';

interface ArrowDownBoldProps extends SVGProps<SVGSVGElement> {
  color?: CSSProperties['color'];
  isActive?: boolean;
}

export const ArrowDownBold = ({
  color,
  isActive,
  ...props
}: ArrowDownBoldProps) => {
  const fill = color ?? COLORS['base-100'];

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: isActive ? 'rotate(-180deg)' : 'rotate(0deg)',
        transition: 'transform .3s ease-in-out',
      }}
      {...props}
    >
      <g id="ic_16/Down arrow">
        <path
          id="Icon"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5636 4.54955C13.9233 4.94895 13.9233 5.5965 13.5636 5.9959L8.65132 11.4504C8.29163 11.8498 7.70845 11.8498 7.34876 11.4504L2.43648 5.9959C2.07678 5.5965 2.07678 4.94895 2.43648 4.54955C2.79617 4.15015 3.37935 4.15015 3.73904 4.54955L8.00004 9.28092L12.261 4.54955C12.6207 4.15015 13.2039 4.15015 13.5636 4.54955Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
